import {useEffect} from 'react';
import {useParams} from 'react-router-dom';

import {useNavigate} from 'shared/web';

import {OverviewPage} from '../../pages/Overview/OverviewPage';
import {getOverviewPath} from '../../utils/routing';

export function IndexRedirect() {
  const navigate = useNavigate();
  const params = useParams();

  // Update URL to /overview in the background
  // Since we're already rendering OverviewPage, this won't cause a visible change
  useEffect(() => {
    navigate(getOverviewPath(params), {replace: true});
  }, [navigate, params]);

  // Render OverviewPage immediately so there's no empty Layout flash
  return <OverviewPage data-testid="overviewPage" />;
}
